import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LineChart',
  props: {
    labels: {},
    dataPoints: {}
  },
  setup(__props: any) {

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale)

const props = __props

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: 'Anxiety Level',
      data: props.dataPoints,
      fill: false,
      borderColor: '#f09943',
      tension: 0.3
    }
  ]
}))

const chartOptions = {
  responsive: true,
  animation: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#a6917b'
      }
    },
    y: {
      min: 0,
      max: 10,
      ticks: {
        stepSize: 1,
        color: '#a6917b'
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (chartData.value)
      ? (_openBlock(), _createBlock(_unref(Line), {
          key: 0,
          data: chartData.value,
          options: chartOptions
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})